import { Box, Button, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import CommonDialog from 'src/components/common/CommonDialog'
import FilterSection from 'src/components/common/filterSection'
import AddEditExerciseDetails from 'src/components/exercise/AddExcerciseDetails'
import BulkUploadPracticeItem, { downloadSamplePracticeItemCsv } from 'src/components/exercise/BulkUploadPracticeItem'
import useQueryTable from 'src/hooks/useQueryTable'
import {
  DeleteExerciseMasterDetailById,
  GetExerciseDetails,
} from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetExerciseDetailTableColumns } from 'src/util/columns'

const ExerciseDetailList = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const [searchText, setSearchText] = useState(null)
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false)

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })


  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'exerciseDetails',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const exerciseId = params.get('_id')

    if (exerciseId) {
      setCustomFilterQuery(prev => ({
        ...prev,
        _id: exerciseId,
      }))
    }
  }, [location.search])

  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteExerciseMasterDetailById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetExerciseDetailTableColumns(), [])

  return (
    <>
      <title>Exercise Details | Langistan</title>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          <FilterSection
            type="Practice Item"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            dispatcher={GetExerciseDetails}
            setCustomFilterQuery={setCustomFilterQuery}
            secondaryButton={
              <Button variant="outlined" color="primary" onClick={() => setIsBulkUploadOpen(true)}>
                + Bulk Upload
              </Button>
            }
          />

          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              toolbarExtra={
                <Button variant="text" size="small" onClick={downloadSamplePracticeItemCsv}>
                  Download Sample CSV
                </Button>
              }
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="Exercise Detail"
              exportApiName="exerciseDetails"
              exportFileName="practice-items.csv"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {/* Bulk upload practice items via CSV */}
          <CommonDialog
            open={isBulkUploadOpen}
            title="Bulk Upload Practice Items"
            onClose={() => setIsBulkUploadOpen(false)}
            maxWidth="sm"
          >
            <BulkUploadPracticeItem
              refetch={refetch}
              toggleDrawer={() => setIsBulkUploadOpen(false)}
            />
          </CommonDialog>

          {/* Add & Update practice Item */}
          <CommonDialog
            open={!!recordToEdit}
            title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} Practice Item`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="md"
          >
            <Box mt={2}>
              <AddEditExerciseDetails
                selectedRow={recordToEdit}
                toggleDrawer={() => setRecordToEdit()}
                refetch={refetch}
              />
            </Box>
          </CommonDialog>

        </Container>
      </Box>
    </>
  )
}

export default ExerciseDetailList
